import * as yup from "yup";
import { Length, Max, Validation } from "../../utils/Validation.utils";
export const PatientDrawerInitialValues = {
    firstName: "",
    lastName: "",
    postalCode: "",
    dateOfBirth: null,
    gradeLevel: null,
    preferredLanguages: [],
    daysAvailable: [],
    timeAvailable: [],
    providerIds: [],
    conditionIds: [],
    insuranceIds: [],
    therapyCategoryIds: [],
    therapySubCategoryIds: []
};
export const PatientDrawerSchema = yup.object().shape({
    firstName: yup
        .string()
        .max(Max.FirstName, Validation.Max)
        .required(Validation.Required),
    lastName: yup
        .string()
        .max(Max.LastName, Validation.Max)
        .required(Validation.Required),
    postalCode: yup
        .string()
        .length(Length.PostalCode, Validation.Length),
    dateOfBirth: yup.date().nullable(),
    gradeLevel: yup.string().nullable(),
    preferredLanguages: yup.array().of(yup.string().required()),
    daysAvailable: yup.array().of(yup.string().required()),
    timeAvailable: yup.array().of(yup.string().required()),
    providerIds: yup.array().of(yup.string().required()),
    conditionIds: yup.array().of(yup.string().required()),
    insuranceIds: yup.array().of(yup.string().required()),
    therapyCategoryIds: yup.array().of(yup.string().required()),
    therapySubCategoryIds: yup.array().of(yup.string().required())
});
